import { render, staticRenderFns } from "./StaffNew.vue?vue&type=template&id=52fc5490"
import script from "./StaffNew.vue?vue&type=script&lang=js"
export * from "./StaffNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports